import { IconCircleArrowRight, IconScript } from "@tabler/icons-react";
import { numericFormatter } from "react-number-format";
import { Link } from "react-router";
import { useStartPageEEG6 } from "../hooks/useStartPageEEG6";
import type { MiniTileItem } from "./MiniTile";
import { MiniTile } from "./MiniTile";

type EEG6MiniTileProps = {
  bookable: boolean;
  projectId?: string;
  year: number;
};

const salesUrl =
  "https://go.node.energy/opti.node-cockpit-nachbuchung-add-on-6-eeg?utm_source=opti.node&utm_medium=link&utm_content=startkachel&utm_campaign=DE_CoCo_6-EEG-Upgrade";

function EEG6MiniTile({ bookable, projectId, year }: EEG6MiniTileProps) {
  const { data, isLoading } = useStartPageEEG6(bookable, year, projectId);

  const items: Array<MiniTileItem> = [
    {
      label: "Summe",
      value: data
        ? numericFormatter((data.sum ?? 0).toString(), {
            decimalSeparator: ",",
            thousandSeparator: ".",
            suffix: " €"
          })
        : ""
    },
    {
      label: "Bezahlt",
      value: data
        ? numericFormatter((data.paid ?? 0).toString(), {
            decimalSeparator: ",",
            thousandSeparator: ".",
            suffix: " €"
          })
        : ""
    }
  ];

  const bookingItem = {
    label: "Das Add-on ist nicht gebucht.",
    value: (
      <Link
        style={{ display: "flex", alignItems: "center", gap: 5 }}
        to={salesUrl}
      >
        <IconCircleArrowRight size="1.3em" />
        Sales kontaktieren
      </Link>
    )
  };

  return (
    <MiniTile
      icon={<IconScript />}
      iconColor="primary"
      isLoading={isLoading}
      items={bookable ? [bookingItem] : items}
      title="§ 6 EEG"
    />
  );
}

export { EEG6MiniTile };
